import { useMemo, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { usePagination, useRowSelect, useTable, useFilters } from 'react-table';
import CourseModal from '../../../EventDetails/components/CourseModal';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
// import { DefaultColumnFilter } from '../../../EventDetails/components/tables/ResourcePersonTable';
import DefaultColumnFilter from '../../../../../../Components/ReactTable/Filters/DefaultColumnFilter';
import ReactTableRender from '../../../../../../Components/ReactTable/ReactTableRender';
import { toNepaliNumber } from '../../../../../../_helpers/_methods';
import { Heading4 } from '../../../../../../Components/FormHeading';
import { FaPlus } from 'react-icons/fa';

function CourseView({ selectedCourses, updateCourseLinks, canAddCourse }) {
  // eslint-disable-next-line no-undef
  const KMS_API = process.env.REACT_APP_KMS;

  const [show, setShow] = useState(false);
  const [newSelectedList, setNewSelectedList] = useState([]);
  const loading = useSelector((state) => state.table.loading);
  const totalCount = useSelector((state) => state.table.totalCount);
  const local = useSelector((state) => state.local.local);

  const defaultColumn = useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }),
    []
  );

  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        disableFilters: true,
        width: '10px'
      },
      {
        Header: <FormattedMessage id="course.knowledge_title" />,
        accessor: 'title'
      },
      {
        Header: <FormattedMessage id="actions" />,
        accessor: 'action',
        disableFilters: true,
        Cell: ({ row: { original } }) => {
          return (
            <span className="d-flex align-items-center ">
              <a
                href={original.link}
                className="btn btn-outline-primary"
                target="_blank"
                rel="noreferrer">
                <FormattedMessage id="course.enroll" />
              </a>
            </span>
          );
        }
      }
    ],
    []
  );
  const data = useMemo(() => {
    if (!selectedCourses) return [];
    let count = 1;
    return selectedCourses.map((course) => {
      return {
        serial_number: local === 'ne' ? toNepaliNumber(count++) : count++,
        title: course.title,
        link: `${KMS_API}/courses/${course?.slug}`
      };
    });
  }, [selectedCourses]);
  const { headerGroups, getTableProps, getTableBodyProps, page, prepareRow } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
      manualPagination: true,
      defaultCanFilter: false,
      defaultColumn
      // manualFilters: true
    },
    useFilters,
    usePagination,
    useRowSelect
  );
  const handleClose = () => setShow(false);
  const handleShowAddModal = () => setShow(true);

  const handleSelectedCourses = (course) => {
    setNewSelectedList(course);
  };

  const addCourseToEvent = () => {
    updateCourseLinks(newSelectedList);
    setShow(false);
  };
  return (
    <Row>
      <Col>
        <div className="d-flex align-items-center justify-content-between">
          <Heading4 className="text-primary mt-2 mb-3">
            <FormattedMessage id="event.courses" />
          </Heading4>

          {canAddCourse && (
            <Button onClick={handleShowAddModal}>
              <FaPlus className="me-2" />
              <FormattedMessage id="add_course" />
            </Button>
          )}
        </div>
        <p className="text-muted" style={{ fontSize: '1.2rem' }}>
          <FormattedMessage id="course.description" />
        </p>
        <Row>
          <ReactTableRender
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            getTableBodyProps={getTableBodyProps}
            page={page}
            prepareRow={prepareRow}
            totalCount={totalCount}
            loading={loading}
            pagination={false}
          />
        </Row>
      </Col>
      {show && (
        <CourseModal
          handleClose={handleClose}
          show={show}
          selectedCourses={newSelectedList}
          action={handleSelectedCourses}
          mainAction={addCourseToEvent}
        />
      )}
    </Row>
  );
}

export default CourseView;
